import React, { Component } from 'react';
import Menu from 'react-burger-menu/lib/menus/slide';
import HeaderLink from './HeaderLink';

class MobileMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuOpen: false
        };
    }

    // This keeps your state in sync with the opening/closing of the menu
    // via the default means, e.g. clicking the X, pressing the ESC key etc.
    handleStateChange(state) {
        this.setState({ menuOpen: state.isOpen });
    }

    // This can be used to close the menu, e.g. when a user clicks a menu item
    closeMenu() {
        this.setState({ menuOpen: false });
    }

    render() {
        return (
            <Menu
                right
                className="MobileMenu"
                isOpen={this.state.menuOpen}
                onStateChange={(state) => this.handleStateChange(state)}>
                <HeaderLink
                    onClick={this.closeMenu.bind(this)}
                    to="/"
                    label="Home"
                />
                <HeaderLink
                    to="https://youthcampsforchrist.campintouch.com/ui/forms/donor/Form"
                    label="Donate"
                />
                {/* TODO Removing outdated header links in favor of donate link */}
                {/*<HeaderLink
                    onClick={this.closeMenu.bind(this)}
                    to="/history"
                    label="History"
                />
                <HeaderLink
                    onClick={this.closeMenu.bind(this)}
                    to="/doctrinal-ethical-covenant"
                    label="Doctrinal and Ethical Covenant"
                />
                <HeaderLink
                    onClick={this.closeMenu.bind(this)}
                    to="/statement-of-purpose"
                    label="Statement of Purpose"
                />
                <HeaderLink
                    onClick={this.closeMenu.bind(this)}
                    to="/board-of-directors"
                    label="Board of Directors"
                />
                <HeaderLink
                    onClick={this.closeMenu.bind(this)}
                    to="/ycfc-staff"
                    label="YCFC Staff"
                />*/}
            </Menu>
        );
    }
}

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/components/Header/MobileMenu.js